import { reportError } from 'src/utils/frontendLogger'
function showChat() {
  if (window.LiveChatWidget) {
    // The old version of live chat (the yellow one)
    window.LiveChatWidget.call('maximize')
  } else if (window.BE_API) {
    window.BE_API.openChatWindow() // The new version of live chat (the blue one)
  } else {
    reportError('Live chat is not available')
  }
}

export { showChat }
